import React from "react";
import { constants } from "../app.constants";

const ContactSection = () => {

  return (
    <div id="contact" className="flex flex-col gap-8 justify-center items-center bg-gradient-to-t from-[#41090b] to-[#150303] py-10">
      <p className="text-4xl pb-3 text-white border-b-2 border-b-primary">Get in touch</p>
      <div className="flex flex-col justify-center gap-4 items-center w-9/12 text-center text-white text-lg">
        <p>
          If you have any questions or inquiries about our Legal & Business Research Solutions, please don't hesitate to get in touch with us. You can reach us by phone at <a className="font-bold text-primary cursor-pointer hover:underline">+92 304 1116670</a> or by email at <a className="font-bold text-primary cursor-pointer hover:underline">info@eastlaw.pk</a>. Our team of experts is ready to assist you with any queries you may have, whether it's about our product features, pricing, or technical support. We value your feedback and suggestions, so feel free to share them with us.
        </p>
        <p>Thank you for considering Eastlaw for your legal research needs.</p>
      </div>
      <div className="flex flex-row gap-8">
        <a href="https://www.facebook.com/eastlaw.pk">
          <img className="w-12 h-auto" src={constants.images.Facebook} alt="Facebook" />
        </a>
        <a href="https://pk.linkedin.com/in/east-law-506aaa148">
          <img className="w-12 h-auto" src={constants.images.LinkedId} alt="LinkedId" />
        </a>
        <a href="https://twitter.com/EastLawpk">
          <img className="w-12 h-auto" src={constants.images.Twitter} alt="Twitter" />
        </a>
        <a href="https://www.instagram.com/eastlaw.pk/">
          <img className="w-12 h-auto" src={constants.images.Instagram} alt="Instagram" />
        </a>
      </div>
      <div className="flex flex-row w-full justify-center">
        <div className="flex flex-col gap-4 px-[3rem] items-center">
          <img src={constants.images.JazzCashLogo} className="w-[8rem]" />
          <p className="text-white">Powered by JazzCash Payments</p>
          <div className="flex flex-row gap-3">
            <img src={constants.images.MasterCardLogo} className="w-[3rem]" />
            <img src={constants.images.VizaCardLogo} className="w-[3rem]" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactSection